import * as React from 'react'
import styled from 'styled-components'
import { TeaserCard } from '../../components/UI/TeaserCard'
import { ThemeName } from '../../lib/constants'
import { typoParagraphS } from '../../lib/styles/Typography'
import { renderRichtextChecklist } from '../../lib/utils/renderRichtextChecklist'
import { TeaserCardBlok } from '../../types'
import { useI18n } from '../../lib/context/i18n'
import { TeaserCardV2 } from '../../components/UI/TeaserCardV2'

export interface TeaserCardItemV2Props {
  children?: React.ReactNode
  justify?: 'left' | 'center'
  direction?: 'row' | 'column'
  step?: string
  width?: string
  blok: TeaserCardBlok
  href?: string
  buttonLabel?: string
  theme?: ThemeName
  color?: string
  price?: string
  disclaimer?: string
  priceDescription?: string
  watermarked?: boolean
  text?: string
}

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .prose p,
  .prose li {
    ${typoParagraphS}
    font-size: 0.8rem;
  }

  .prose ul li:not(:last-child) {
    margin-bottom: 0.2rem;
  }
`

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`

export const TeaserCardItemV2 = ({ blok, direction = 'column', children, justify = 'left', width, step, href, theme }: TeaserCardItemV2Props) => {

  const { getTranslatedUrlFromLink } = useI18n()

  const hrefFromBlok = blok.link && (blok.link.url || blok.link.cached_url) ? getTranslatedUrlFromLink(blok.link) : href;

  const [customerPortalHost, setCustomerPortalHost] = React.useState('')

  React.useEffect(() => {
    setCustomerPortalHost(
      process.env.CUSTOMER_PORTAL_HOST
      || (window !== undefined && window.location.hostname.includes('staging') ?
        'https://portal.pdf-tools-staging.com/' : 'https://portal.pdf-tools.com/')
    )
  }, [])

  return (
    <TeaserCardV2
      price={blok?.price}
      watermarked={blok?.watermarked}
      text={blok?.text}
      color={blok?.color}
      disclaimer={blok?.disclaimer}
      priceDescription={blok?.priceDescription}
      // do this if block.link is not empty
      href={hrefFromBlok || customerPortalHost}
      title={blok.title}
      asset={blok.image}
      step={step}
      justify={justify}
      direction={direction}
      buttonLabel={blok.buttonLabel}
    >
      <ContentWrapper>
        <div className="prose">{renderRichtextChecklist(blok.description)}</div>
        {!!children && <Footer>{children}</Footer>}
      </ContentWrapper>
    </TeaserCardV2>
  )
}
